import { DynamicStandaloneShowsSlider } from '@/components/ShowsSlider';
import { LabradorComponent } from '@/types/component';

const LabradorShowsSlider: LabradorComponent = ({ descendants }) => {
  const showsItems = descendants.map((descendant) => descendant.data);

  return <DynamicStandaloneShowsSlider shows={showsItems} />;
};

export default LabradorShowsSlider;
